module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-yellow.be52f77e.svg";